import Form from "react-bootstrap/Form";
import {
  FaPencilAlt,
  FaRegCheckCircle,
  FaRegTimesCircle,
  FaTrash,
  FaUserPlus,
  FaEyeSlash,
} from "react-icons/fa";
import { getTotale } from "./utils/helpers";

/**
 * SchedaHeader - Dark "Total exposure" hero card for the scheda detail page
 * (the schede list uses the more compact SchedaRow instead), styled after the
 * Stitch "Dettaglio Scheda Mobile" / "Dettaglio Scheda Spese: Dining Q4"
 * reference screens.
 */
const SchedaHeader = ({
  scheda,
  // Title editing props
  isEditing,
  titolo,
  erroLength,
  onLongPress,
  onChange,
  cancelEdit,
  updateSchedataTitolo,
  // Action handlers
  onShare,
  onDelete,
  onHide,
}) => {
  if (isEditing) {
    return (
      <div className="dashboard-card px-3 pt-3 pb-2 mb-3">
        <div className="d-flex align-items-center gap-2">
          <Form.Group className="flex-grow-1 mb-0">
            <Form.Control
              className="dashboard-input"
              type="text"
              id="titolo"
              maxLength="21"
              name="titolo"
              value={titolo}
              placeholder="titolo"
              onChange={onChange}
              autoFocus
            />
          </Form.Group>
          <button
            type="button"
            className="scheda-row-actions-toggle"
            aria-label="Cancel"
            onClick={cancelEdit}
          >
            <FaRegTimesCircle size={18} />
          </button>
          <button
            type="button"
            className="scheda-row-actions-toggle"
            aria-label="Save"
            onClick={updateSchedataTitolo}
          >
            <FaRegCheckCircle size={18} />
          </button>
        </div>
        {erroLength && (
          <small className="text-danger">Limit characters reached</small>
        )}
      </div>
    );
  }

  const isShared = !!scheda.isCondiviso;

  return (
    <div className="scheda-hero mb-3">
      <div className="d-flex justify-content-between align-items-start gap-3">
        <div style={{ minWidth: 0 }}>
          <span className="scheda-hero-badge">{isShared ? "Shared" : "Private"}</span>
          <h3 className="scheda-hero-title mt-2 mb-3" style={{ textTransform: "capitalize" }}>
            {scheda.titolo}
          </h3>
          <p className="scheda-hero-label mb-1">Total exposure</p>
          <h1 className="scheda-hero-value mb-0">€ {getTotale(scheda.notaSpese)}</h1>
        </div>
        <div className="d-flex gap-2 flex-shrink-0">
          <button
            type="button"
            className="scheda-hero-icon-btn"
            aria-label="Edit title"
            onClick={onLongPress}
          >
            <FaPencilAlt size={14} />
          </button>
          {scheda.myPermissions?.canEliminareScheda && (
            <button
              type="button"
              className="scheda-hero-icon-btn scheda-hero-icon-btn--danger"
              aria-label="Delete scheda"
              onClick={onDelete}
            >
              <FaTrash size={14} />
            </button>
          )}
        </div>
      </div>

      <div className="d-flex flex-wrap gap-2 mt-3">
        <button type="button" className="scheda-hero-action" onClick={onShare}>
          <FaUserPlus size={12} /> Share
        </button>
        {onHide && scheda.myPermissions?.canNascodereScheda && (
          <button type="button" className="scheda-hero-action" onClick={onHide}>
            <FaEyeSlash size={12} /> Hide
          </button>
        )}
      </div>
    </div>
  );
};

export default SchedaHeader;
